export const FaceDatabase = {
  title: "Face Database Management",
  database: "Face Database",
  databases: "Face Databases",
  subject: "Person",
  subjects: "People",
  image: "Image",
  images: "Images",
  create: "Create",
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  cancel: "Cancel",
  upload: "Upload",
  name: "Name",
  description: "Description",
  gender: "Gender",
  nationality: "Nationality",
  required: "Required",
  searchSubjects: "Search people...",
  noResultsFound: "No results found",
  tryDifferentSearch: "Try adjusting your search terms",
  confirmDelete: 'Are you sure you want to delete "{name}"?',
  maxImages: "Maximum 10 images per person",
  imageLimit: "Image limit reached",
  noSubjects: "No people in this database",
  noImages: "No images for this person",
  noDatabases: "No face databases available",
  createDatabase: "Create Face Database",
  createSubject: "Create Person",
  linkExistingSubject: "Link Existing Person",
  selectExistingSubjects: "Project people",
  loadingProjectSubjects: "Loading project people...",
  noLinkableSubjects: "No project people available to link",
  linkExistingSubjectHelp:
    "{count} people from this project are available to link to this database.",
  uploadImages: "Upload Images",
  selectDatabase: "Select a database to view its content",
  selectSubject: "Select a person to view their images",
  databaseName: "Database Name",
  databaseType: "Database Type",
  personName: "Person Name",
  dropImages: "Drop images here or click to select",
  dragImages: "Drag images here",
  processing: "Processing...",
  detecting: "Detecting faces...",
  facesDetected: "Faces detected",
  noFacesDetected: "No faces detected",
  noFacesDetectedDescription:
    'This detector works best with faces that are close or occupy a good portion of the photo. <ul style="padding-left: 15px"><li>Try uploading an image with larger or closer faces.</li><li>Or manually draw the face areas on the image.</li></ul>',
  faceDetection: "Face Detection",
  assignFace: "Assign face to person",
  editBoundingBox: "Edit bounding box",
  deleteBoundingBox: "Delete bounding box",
  drawBoundingBox: "Draw bounding box",
  confirmUpload: "Confirm upload",
  imageMetadata: "Image Metadata",
  fileName: "File Name",
  dimensions: "Dimensions",
  fileSize: "File Size",
  created: "Created",
  lastModified: "Last Modified",
  hash: "Hash",
  goBack: "Go Back",
  selectImages: "Select Images",
  addBoundingBoxManually: "Add faces manually",
  saveAnnotations: "Save Annotations",
  noFacesAssignedToUpload: "No faces assigned to upload",
  createNewPerson: "Create new person",
  assignedTo: "Assigned to",
  confidence: "Confidence",
  assignToPerson: "Assign to person",
  databaseNotFound: "Database not found",
  multipleImageSupport:
    "Support for single or multiple images. No size limit for original images.",
  addMoreImages: "Add more images",
  imagesLoaded: "Images loaded",
  processFaces: "Process faces",
  noFacesDetectedInImage: "No faces detected in this image",
  facesDetectedSuffix: "faces detected",
  selectImageToProcess: "Select an image to process faces",
  removeSubjectAction: "Remove person",
  duplicateSubjectTitle: "Person already exists",
  duplicateSubjectPrompt:
    'A person named "{name}" already exists in this project. Would you like to link that existing person to this database instead?',
  externalEngineRegistrationInfo:
    "This database is connected to {engine}. Creating or linking a person will register them in the external engine and may take a moment.",
  removeSubjectUnlink:
    'This will remove "{name}" from this database. The person and their images will be preserved because they still belong to other databases.',
  removeSubjectDelete:
    'This will permanently delete "{name}" and all associated images because this is the last database linked to this person.',
  removeSubjectExternalEngine:
    "If this is the last {engine} database linked to this person, they will also be removed from that external recognition engine.",
  confirmUnlinkSubject:
    'Are you sure you want to unlink "{name}"? If this person is not linked to any other database, they will be deleted.',
  confirmDeleteImageTitle: "Delete Face",
  confirmDeleteImage:
    "Are you sure you want to delete this face? This action cannot be undone.",
  helpTooltip:
    "You can drag your cursor to draw bounding boxes around faces. Click to edit or delete existing boxes.",
  manualCrop: "Manual",
  editedCrop: "Edited",
  reAnalizeFaces: "Re-analyze faces",
  removeImage: "Remove Image",
  retryUpload: "Retry",
  uploadErrors: "Upload Errors",
  errors: {
    invalidFormat: "Invalid image format. Only JPEG files are allowed.",
    invalidSize: "Invalid image size. Images must be at least 36x36 pixels.",
    fileTooBig: "File too large. Maximum size is 100KB.",
    tooManyImages: "Too many images. Maximum 10 images per person.",
    uploadFailed: "Failed to upload images",
    deleteFailed: "Failed to delete image",
    createFailed: "Failed to create",
    updateFailed: "Failed to update",
    unlinkFailed: "Failed to unlink person",
    removeFailed: "Failed to remove person from the database",
    linkFailed: "Failed to link person to the database",
    loadFailed: "Failed to load data",
    nameTooLong: "Name is too long. Maximum 255 characters.",
    nameRequired: "Name is required",
    descriptionTooLong: "Description is too long. Maximum 500 characters.",
    nationalityTooLong: "Nationality is too long. Maximum 100 characters.",
    bboxTooSmall: "Bounding box too small. Minimum size is 36px.",
    errorUploadingImages: "Error uploading images",
    errorLoadingDatabases: "Error loading face databases",
    errorLoadingSubjects: "Error loading subjects",
    errorLoadingImages: "Error loading images",
    reDetectionFailed: "Error re-detecting faces",
    duplicateName: "A person with this name already exists in this project.",
    duplicateAlreadyLinked:
      "A person with this name already exists and is already linked to this database.",
    subjectProjectMismatch:
      "This person belongs to a different project and cannot be linked here.",
    incompatibleEngineType:
      "This person is registered with {subjectEngineType} and cannot be linked to a {databaseType} database.",
    syncFailed: "Failed to synchronize person with the external engine",
    partialUpload:
      "Successfully uploaded {successCount} images, but {errorCount} failed.",
  },
  success: {
    uploaded: "Images uploaded successfully",
    deleted: "Image deleted successfully",
    created: "Created successfully",
    updated: "Updated successfully",
    imagesUploadedSuccessfully: "Images uploaded successfully",
    facesReDetected: "Faces re-detected successfully",
    subjectLinked: "Person linked successfully",
    subjectsLinked: "{count} people linked successfully",
    subjectRemoved: "Person removed from this database",
    subjectDeleted: "Person and images deleted permanently",
    subjectSynced: "Person synchronized successfully",
    existingSubjectSelected: "Existing person selected successfully",
  },
  databaseTypes: {
    DEFAULT: "Standard",
    SEVENTH_SENSE: "Seventh Sense",
  },
  engineTypes: {
    DEFAULT: "Standard",
    SEVENTH_SENSE: "Seventh Sense",
  },
  genderOptions: {
    MALE: "Male",
    FEMALE: "Female",
    OTHER: "Other",
    UNSPECIFIED: "Unspecified",
  },
  sync: {
    action: "Sync person",
    states: {
      SYNCHRONIZING: "Synchronizing...",
      OK: "Synchronized Face Database",
      ERROR: "Face Database needs synchronization",
      ERROR_ON_SYNC: "Error during synchronization, please retry",
      UNKNOWN_STATE: "Unknown state",
    },
    notification: {
      message: "Synchronizing",
      description1: "The synchronization process with ",
      description2: "has started",
    },
  },
};
